import { CountUp } from "./CountUp";
import { ValueHero } from "./ValueHero";
import { VALUE_STATS } from "@/data/content";

export const SOLUTION_HEADING = "Write, review & revise submittals automatically";

export const ValueSection = () => (
  <section id="value" className="cd-section bg-[#292929]" data-testid="value-section">
    <div className="mx-auto max-w-[1360px] px-5 sm:px-8">
      <div className="cd-reveal max-w-4xl">
        <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#ff6600]" data-testid="value-eyebrow">The solution</p>
        <h2 className="mt-4 font-display text-3xl font-semibold leading-[1.1] tracking-[-0.025em] text-[#f5f5ee] sm:text-4xl lg:text-[44px]" data-testid="value-title">
          {SOLUTION_HEADING}
        </h2>
      </div>
      <ValueHero />
      <div className="cd-reveal grid grid-cols-1 gap-px border-x border-b border-[#4a4a46] bg-[#4a4a46] sm:grid-cols-3">
        {VALUE_STATS.map((s, i) => (
          <article key={s.caption} className="cd-value relative bg-[#292929] p-6 sm:p-8" data-testid={`value-stat-${i + 1}`}>
            <p className="font-display text-5xl font-semibold leading-[1.05] tracking-[-0.04em] text-[#f5f5ee] lg:text-[44px] xl:text-5xl">
              <CountUp value={s.value} testId={`value-stat-value-${i + 1}`} />
            </p>
            <p className="mt-4 text-[15px] leading-relaxed text-[#d8d8d0]" data-testid={`value-stat-caption-${i + 1}`}>{s.caption}</p>
          </article>
        ))}
      </div>
      <p className="mt-6 font-mono text-[11px] leading-relaxed text-[#94948a]" data-testid="value-footnote">
        Typical results per door hardware submittal.
      </p>
    </div>
  </section>
);
